import React from "react";
import LiveEventsPage from "../../pages/LiveEventsPage/live-events-page";
import { RootState } from "../../models/RootState";

type storeProps = {
  operatorId: string;
};

const LiveEventsView: React.FC = () => {
  return (
    <>
      <LiveEventsPage />
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    operatorId: state.auth.operatorId,
    loggedIn: state.auth.loggedIn,
  };
};

// export default connect(mapStateToProps, null)(LiveEventsView);
export default LiveEventsView;
